module.exports = __webpack_public_path__ + "static/media/link-aja.a292f96e.svg";